module.exports = __webpack_public_path__ + "img/logo.08a6c3dc.png";